<app-loader [isBusy]="isBusy">
    <ng-template>
        <div class="modal-header">
            <h4 class="modal-title">{{ isEditMode ? 'Edit' : ('Add' | translate) }} {{ 'Cargo Item' | translate }}</h4>
            <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body p-0">
            <app-loader [isBusy]="false">
                <ng-template>
                    <form class="pt-3" [formGroup]="form">
                        @if (containerized) {
                            <div class="disabledLabels">
                                <div class="row">
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="shippingLineOrganizationId"
                                            labelText="{{ 'Shipping Line' | translate }}"
                                            cacheKey="{{ manifestId }}-shipping-lines"
                                            [observableInput]="organizations$"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="bookingNumber"
                                            labelText="{{ 'Booking Nbr.' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="billOfLadingNbr"
                                            labelText="{{ 'B/L Nbr.' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="containerNumber"
                                            labelText="{{ 'Container' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="containerIsoCodeId"
                                            labelText="{{ 'ISO Code' | translate }}"
                                            codeListName="ContainerISOCode"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="containerTareWeight"
                                            labelText="{{ 'Tare Weight (kg)' | translate }}"
                                            [decimal]="true"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="containerStatusId"
                                            labelText="{{ 'Cont. Status' | translate }}"
                                            codeListName="FullOrEmpty"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="loadTypeId"
                                            labelText="{{ 'Container Load Type' | translate }}"
                                            codeListName="LoadType"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="sealNumbers"
                                            labelText="{{ 'Seal Numbers' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="sealTypeId"
                                            labelText="{{ 'Seal Type' | translate }}"
                                            codeListName="SealType"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textarea
                                            formControlName="cargoDescription"
                                            labelText="{{ 'Cargo Description' | translate }}"
                                            [collapsible]="true"></form-textarea>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoReference"
                                            labelText="{{ 'Cargo Reference (Marking)' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="cargoTypePerSystemId"
                                            labelText="{{ 'Cargo Type' | translate }}"
                                            codeListName="CodeListCargoTypePerSystemForManifest"
                                            [forTOSSystem]="'MSW'"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="numberOfPackages"
                                            labelText="{{ 'Number Of Packages' | translate }}"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="packagingTypeId"
                                            labelText="{{ 'Pack. Type' | translate }}"
                                            codeListName="CodeListCargoPackagingTypePerSystemForManifest"
                                            [forTOSSystem]="'CUST'"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="cargoGrossWeight"
                                            labelText="{{ 'Gross Weight (kg)' | translate }}"
                                            [emptyIfZero]="true"
                                            [decimal]="true"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="cargoNetWeight"
                                            labelText="{{ 'Net Weight (kg)' | translate }}"
                                            [emptyIfZero]="true"
                                            [decimal]="true"></form-number>
                                    </div>
                                    @if (form.controls.weightInVacuum.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-number
                                                formControlName="weightInVacuum"
                                                labelText="{{ 'Weight in Vacuum (kg)' | translate }}"
                                                [emptyIfZero]="true"
                                                [decimal]="true"></form-number>
                                        </div>
                                    }
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="cargoVolume"
                                            labelText="{{ 'Volume (m3)' | translate }}"
                                            [emptyIfZero]="true"
                                            [decimal]="true"></form-number>
                                    </div>
                                    @if (form.controls.density.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-number
                                                formControlName="density"
                                                labelText="{{ 'Density (kg/m3)' | translate }}"
                                                [decimal]="true"
                                                [roundToPlaces]="5"></form-number>
                                        </div>
                                    }
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="vgm"
                                            labelText="{{ 'VGM (kg)' | translate }}"
                                            [decimal]="true"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-checkbox
                                            labelText="{{ 'Dangerous Cargo' | translate }}"
                                            [value]="showIMDG"
                                            (click)="showIMDG = !showIMDG"></form-checkbox>
                                    </div>
                                    @if (showIMDG) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="imdgClassId"
                                                labelText="{{ 'IMDG Nbr.' | translate }}"
                                                codeListName="ImdgClass"></form-dropdown>
                                        </div>
                                    }
                                    @if (showIMDG) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="unNumberId"
                                                labelText="{{ 'UN Nbr.' | translate }}"
                                                codeListName="UnNumber"></form-dropdown>
                                        </div>
                                    }
                                    @if (showIMDG) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="packingGroupId"
                                                labelText="{{ 'Pack. Group' | translate }}"
                                                codeListName="ImdgPackingGroup"></form-dropdown>
                                        </div>
                                    }
                                    @if (showIMDG) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textbox
                                                formControlName="flashpoint"
                                                labelText="{{ 'Flashpoint (in °C) ' | translate }}"></form-textbox>
                                        </div>
                                    }
                                    @if (showIMDG) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textarea
                                                formControlName="cargoTechnicalDescription"
                                                labelText="{{
                                                    'Cargo Technical Description' | translate
                                                }}"></form-textarea>
                                        </div>
                                    }
                                    @if (showIMDG) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textbox
                                                formControlName="locationOnBoard"
                                                labelText="{{ 'Location On Board ' | translate }}"></form-textbox>
                                        </div>
                                    }
                                    @if (showIMDG) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textbox
                                                formControlName="dgContact"
                                                labelText="{{ 'DG Contact' | translate }}"></form-textbox>
                                        </div>
                                    }
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="temperatureFrom"
                                            labelText="{{ 'Min. Temperature (°C)' | translate }}"
                                            [decimal]="true"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="temperatureTo"
                                            labelText="{{ 'Max. Temperature (°C)' | translate }}"
                                            [decimal]="true"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="countryOfOriginId"
                                            labelText="{{ 'Country Of Origin' | translate }}"
                                            codeListName="Flag"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="portOfLoadingId"
                                            labelText="{{ 'POL' | translate }}"
                                            codeListName="Port"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="portOfDischargeId"
                                            labelText="{{ 'POD' | translate }}"
                                            codeListName="Port"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="fpodId"
                                            labelText="{{ 'FPOD' | translate }}"
                                            codeListName="Port"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoShipper"
                                            labelText="{{ 'Shipper' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoConsignee"
                                            labelText="{{ 'Consignee' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoNotify"
                                            labelText="{{ 'Notifier' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="cargoCustomsStatusId"
                                            labelText="{{ 'Customs Status' | translate }}"
                                            codeListName="CustomsStatus"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="customsDeclarationNumber"
                                            labelText="{{ 'Customs Declaration Number' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="customsDeclarationItemNumber"
                                            labelText="{{
                                                'Customs Declaration Item (Number)' | translate
                                            }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="customsArticleNumber"
                                            labelText="{{ 'Customs Article Number' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="taricCode"
                                            labelText="{{ 'TARIC Code' | translate }}"></form-textbox>
                                    </div>
                                    <div
                                        class="col-xl-3 col-sm-6 col-xs-12"
                                        kendoTooltip
                                        title="{{
                                            'Enter the unique Administrative Reference Code (ARC) that identifies the movement of excise goods under duty suspension within the EMCS (Excise Movement and Control System).'
                                                | translate
                                        }}">
                                        <form-textbox
                                            labelText="{{ 'e-AD (ARC) Number' | translate }}"
                                            formControlName="eadARCNumber"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            labelText="{{ 'Customs Warehouse Type' | translate }}"
                                            codeListName="CustomsWarehouseType"
                                            formControlName="customsWarehouseTypeId"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-checkbox
                                            labelText="{{ 'In Transit' | translate }}"
                                            formControlName="inTransit"></form-checkbox>
                                    </div>
                                    <div
                                        class="col-xl-3 col-sm-6 col-xs-12"
                                        kendoTooltip
                                        title="{{
                                            'Check if the goods have EU status, as evidenced by a T2L or equivalent document.'
                                                | translate
                                        }}">
                                        <form-checkbox
                                            labelText="{{ 'T2L' | translate }}"
                                            formControlName="t2L"></form-checkbox>
                                    </div>
                                </div>
                            </div>
                        }

                        @if (!containerized) {
                            <div class="disabledLabels">
                                <div class="row">
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="bookingNumber"
                                            labelText="{{ 'Booking Nbr.' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="billOfLadingNbr"
                                            labelText="{{ 'B/L Nbr.' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textarea
                                            formControlName="cargoDescription"
                                            labelText="{{ 'Cargo Description' | translate }}"
                                            [collapsible]="true"></form-textarea>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoReference"
                                            labelText="{{ 'Cargo Reference (Marking)' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="cargoRealizationTypeId"
                                            labelText="{{ 'Method Of Measurement' | translate }}"
                                            codeListName="CargoRealizationType"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="cargoTypePerSystemId"
                                            labelText="{{ 'Cargo Type' | translate }}"
                                            codeListName="CodeListCargoTypePerSystemForManifest"
                                            [forTOSSystem]="forTosSystem"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="numberOfPackages"
                                            labelText="{{ 'Number Of Packages' | translate }}"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="packagingTypeId"
                                            labelText="{{ 'Pack. Type' | translate }}"
                                            codeListName="CodeListCargoPackagingTypePerSystemForManifest"
                                            [forTOSSystem]="'CUST'"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="cargoGrossWeight"
                                            labelText="{{ 'Gross Weight (kg)' | translate }}"
                                            [emptyIfZero]="true"
                                            [decimal]="true"></form-number>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="cargoNetWeight"
                                            labelText="{{ 'Net Weight (kg)' | translate }}"
                                            [emptyIfZero]="true"
                                            [decimal]="true"></form-number>
                                    </div>
                                    @if (form.controls.weightInVacuum.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-number
                                                formControlName="weightInVacuum"
                                                labelText="{{ 'Weight in Vacuum (kg)' | translate }}"
                                                [emptyIfZero]="true"
                                                [decimal]="true"></form-number>
                                        </div>
                                    }
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-number
                                            formControlName="cargoVolume"
                                            labelText="{{ 'Volume (m3)' | translate }}"
                                            [emptyIfZero]="true"
                                            [decimal]="true"></form-number>
                                    </div>
                                    @if (form.controls.density.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-number
                                                formControlName="density"
                                                labelText="{{ 'Density (kg/m3)' | translate }}"
                                                [decimal]="true"
                                                [roundToPlaces]="5"></form-number>
                                        </div>
                                    }
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="mswCargoRegulationId"
                                            labelText="{{ 'DG Classification' | translate }}"
                                            codeListName="MswCargoRegulation"></form-dropdown>
                                    </div>
                                    @if (form.controls.imdgClassId.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="imdgClassId"
                                                labelText="{{ 'IMDG Nbr.' | translate }}"
                                                codeListName="ImdgClass"></form-dropdown>
                                        </div>
                                    }
                                    @if (form.controls.unNumberId.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="unNumberId"
                                                labelText="{{ 'UN Nbr.' | translate }}"
                                                codeListName="UnNumber"></form-dropdown>
                                        </div>
                                    }
                                    @if (form.controls.packingGroupId.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="packingGroupId"
                                                labelText="{{ 'Pack. Group' | translate }}"
                                                codeListName="ImdgPackingGroup"></form-dropdown>
                                        </div>
                                    }
                                    @if (form.controls.marpolCategoryId.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="marpolCategoryId"
                                                labelText="{{ 'Marine Pollutant' | translate }}"
                                                codeListName="MarpolCategory"></form-dropdown>
                                        </div>
                                    }
                                    @if (form.controls.ibcCodeId.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="ibcCodeId"
                                                labelText="{{ 'IBC Code' | translate }}"
                                                codeListName="IBCCode"></form-dropdown>
                                        </div>
                                    }
                                    @if (form.controls.imsbcCodeId.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-dropdown
                                                formControlName="imsbcCodeId"
                                                labelText="{{ 'IMSBC Code' | translate }}"
                                                codeListName="ImsbcCode"></form-dropdown>
                                        </div>
                                    }
                                    @if (form.controls.flashpoint.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textbox
                                                formControlName="flashpoint"
                                                labelText="{{ 'Flashpoint (in °C) ' | translate }}"></form-textbox>
                                        </div>
                                    }
                                    @if (form.controls.cargoTechnicalDescription.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textarea
                                                formControlName="cargoTechnicalDescription"
                                                labelText="{{
                                                    'Cargo Technical Description' | translate
                                                }}"></form-textarea>
                                        </div>
                                    }
                                    @if (form.controls.locationOnBoard.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textbox
                                                formControlName="locationOnBoard"
                                                labelText="{{ 'Location On Board ' | translate }}"></form-textbox>
                                        </div>
                                    }
                                    @if (form.controls.dgContact.enabled) {
                                        <div class="col-xl-3 col-sm-6 col-xs-12">
                                            <form-textbox
                                                formControlName="dgContact"
                                                labelText="{{ 'DG Contact' | translate }}"></form-textbox>
                                        </div>
                                    }
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="countryOfOriginId"
                                            labelText="{{ 'Country Of Origin' | translate }}"
                                            codeListName="Flag"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="portOfLoadingId"
                                            labelText="{{ 'POL' | translate }}"
                                            codeListName="Port"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="portOfDischargeId"
                                            labelText="{{ 'POD' | translate }}"
                                            codeListName="Port"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="fpodId"
                                            labelText="{{ 'FPOD' | translate }}"
                                            codeListName="Port"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoShipper"
                                            labelText="{{ 'Shipper' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoConsignee"
                                            labelText="{{ 'Consignee' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="cargoNotify"
                                            labelText="{{ 'Notifier' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            formControlName="cargoCustomsStatusId"
                                            labelText="{{ 'Customs Status' | translate }}"
                                            codeListName="CustomsStatus"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="customsDeclarationNumber"
                                            labelText="{{ 'Customs Declaration Number' | translate }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="customsDeclarationItemNumber"
                                            labelText="{{
                                                'Customs Declaration Item (Number)' | translate
                                            }}"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-textbox
                                            formControlName="customsArticleNumber"
                                            labelText="{{ 'Customs Article Number' | translate }}"></form-textbox>
                                    </div>
                                    <div
                                        class="col-xl-3 col-sm-6 col-xs-12"
                                        kendoTooltip
                                        title="{{
                                            'Enter the unique Administrative Reference Code (ARC) that identifies the movement of excise goods under duty suspension within the EMCS (Excise Movement and Control System).'
                                                | translate
                                        }}">
                                        <form-textbox
                                            labelText="{{ 'e-AD (ARC) Number' | translate }}"
                                            formControlName="eadARCNumber"></form-textbox>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            labelText="{{ 'Customs Warehouse Type' | translate }}"
                                            codeListName="CustomsWarehouseType"
                                            formControlName="customsWarehouseTypeId"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            labelText="{{ 'Warehouse Type' | translate }}"
                                            codeListName="WarehouseType"
                                            formControlName="warehouseTypeId"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12">
                                        <form-dropdown
                                            labelText="{{ 'Warehouse' | translate }}"
                                            formControlName="warehousePerSystemId"
                                            [observableInput]="warehouse$"
                                            [automaticPopulateWithFirstValue]="true"
                                            [selectLabel]="selectLabel"></form-dropdown>
                                    </div>
                                    <div class="col-xl-3 col-sm-6 col-xs-12" style="margin-top: 10px">
                                        <form-checkbox
                                            labelText="{{ 'In Transit' | translate }}"
                                            formControlName="inTransit"></form-checkbox>
                                    </div>
                                    <div
                                        class="col-xl-3 col-sm-6 col-xs-12"
                                        kendoTooltip
                                        title="{{
                                            'Check if the goods have EU status, as evidenced by a T2L or equivalent document.'
                                                | translate
                                        }}">
                                        <form-checkbox
                                            labelText="{{ 'T2L' | translate }}"
                                            formControlName="t2L"></form-checkbox>
                                    </div>
                                </div>
                            </div>
                        }
                    </form>
                </ng-template>
            </app-loader>
        </div>

        <div class="modal-footer">
            <button class="btn btn-sm btn-primary mr-2" [disabled]="getIsFormDisabled" (click)="saveCargoItem()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ isEditMode ? 'Save' : ('Add' | translate) }}
            </button>
            <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </div>
    </ng-template>
</app-loader>
